/**
 * 주요 직책 / 팀장 / 파트장 / 사원 순으로, 가나다 정렬입니다.
 * 주요 직책만 record를 작성하고, 사원은 position을 작성하지 않습니다.
 */
const team = [
  {
    img: "/img/team/서영규님.jpg",
    name: "서영규",
    position: "CISO / CPO",
    word: "Let’s all be happy.",
    record: "동국대 국제정보대학원 정보보호 (석)\n前 SK온 부사장",
  },
  {
    img: "/img/team/이선표.jpg",
    name: "이선표",
    position: "전무",
    word: "Start now, get perfect later!",
    record: `호서대학교  기술경영전문대학원  / 박사
    前 ㈜비아이씨엔에스 / 상무`,
  },
  {
    img: "/img/team/이성.jpg",
    name: "이성",
    position: "CTO",
    word: "Do More With Less",
    record: `한양대학교  물리학과  / 학사
    前 티맥스BI / 연구본부장(CTO) / 상무이사`,
  },
  {
    img: "/img/team/지윤님.png",
    name: "이지윤",
    position: "상무",
    word: "어제의 나와 경쟁하는 사람 !!",
    record: "",
  },
  {
    img: "/img/team/상원님.jpeg",
    name: "황상원",
    position: "실장",
    word: "잘부탁드립니다. SNP 화이팅!",
    record: "",
  },
  {
    img: "/img/team/윤상현님.jpg",
    name: "윤상현",
    position: "팀장",
    word: "안녕하십니까",
    record: "",
  },
  {
    img: "/img/team/민준님.png",
    name: "김민준",
    position: "",
    word: "항상 감사합니다😊",
    record: "",
  },
  {
    img: "/img/team/김민준님_마케팅.jpg",
    name: "김민준",
    position: "",
    word: "착한 사람이 되겠습니다.",
    record: "",
  },
  {
    img: "/img/team/김유리님.png",
    name: "김유리",
    position: "",
    word: "안녕하세요",
    record: "",
  },
  {
    img: "/img/team/준엽님.jpg",
    name: "김준엽",
    position: "",
    word: "화이팅!",
    record: "",
  },
  {
    img: "/img/team/백상빈.jpg",
    name: "백상빈",
    position: "",
    word: "The journey is the best reward",
    record: "",
  },
  {
    img: "/img/team/박소륜님.png",
    name: "박소륜",
    position: "",
    word: "하쿠나마타타",
    record: "",
  },
  {
    img: "/img/team/충암님.png",
    name: "박충암",
    position: "",
    word: "안녕하십니까! 잘 부탁드립니다!",
    record: "",
  },
  {
    img: "/img/team/서준현.jpg",
    name: "서준현",
    position: "",
    word: "수고했어 오늘도",
    record: "",
  },
  {
    img: "/img/team/송정원.png",
    name: "송정원",
    position: "",
    word: "변화를 두려워하지 않는 사람",
    record: "",
  },
  {
    img: "/img/team/철현님.png",
    name: "안철현",
    position: "",
    word: "이걸 끼고 일해야 능률이 올라갑니다",
    record: "",
  },
  {
    img: "/img/team/동욱님.jpg",
    name: "정동욱",
    position: "",
    word: "Ad astra, per aspera. (역경을 극복하고 성공하다.)",
    record: "",
  },
  {
    img: "/img/team/영하님.png",
    name: "차영하",
    position: "",
    word: "",
    record: "",
  },
  {
    img: "/img/team/한지수님.png",
    name: "한지수",
    position: "",
    word: "직선이 아니어도 괜찮아",
    record: "",
  },
];

export default team;
